<template>
  <div class="videointerview-groups">
    <new-group />

    <template v-if="groups.length">
      <table-groups v-if="groups_fulled" class="table" />

      <new-connection v-if="questions_without_group.length" class="new-connection" />

      <vbutton :disabled="loading" class="button" label="common.save" @click="save_connections" />
    </template>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import TableGroups from './table.vue';
import NewConnection from './new-connection.vue';
import NewGroup from './new-group';

export default {
  name: 'VacancyVideointerviewGroups',

  components: {
    NewGroup,
    NewConnection,
    TableGroups
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    ...mapGetters('vacancy_new/video_interview_groups', ['questions_without_group', 'groups_fulled', 'groups']),
  },

  methods: {
    ...mapActions('vacancy_new/video_interview_groups', ['save']),

    save_connections() {
      this.loading = true;

      this.save()
        .then(() => {
          this.$noty.success(this.$tr('vacancy.preferences.modals.saveSuccess.text'));
        })
        .catch(() => {
          this.$noty.error(this.$tr('vacancy.preferences.modals.saveFailure.text'));
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.videointerview-groups {
  max-width: 1100px;

  .table {
    margin: 10px 0;
  }

  .new-connection {
    margin: 10px 0;
  }

  .button {
    margin: 10px 0;
  }
}
</style>
